import Parent from './Parent';

export default Parent;
